import React, { useState } from "react";
import {
  Tooltip,
  Spin,
  Popover,
  Button,
  Avatar,
  Tag,
  Card,
  Descriptions,
  Flex,
  Space,
  Typography,
} from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { EyeOutlined } from "@ant-design/icons";
import clientService from "../services/clientService";
import usePermissions from "../hooks/usePermissions";
import DynamicTable from "../page-components/All Clients/DynamicTable";
import { useMediaQuery } from "react-responsive";
// import "./Layout/layout.module.css"
import { useNavigate } from "react-router-dom";
const formatFieldName = (fieldName) => {
  return fieldName
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/^\w/, (c) => c.toUpperCase()); // Capitalize the first letter
};

const formatDate = (date) => moment(date).local().format("DD-MM-YYYY HH:mm a"); // Convert to local time

const SearchDescriptionsList = ({ items, type }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [loading, setLoading] = useState(false);
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();
  const [expandedRows, setExpandedRows] = useState({});
  const [tasksData, setTasksData] = useState([]);
  const [loadingIndex, setLoadingIndex] = useState(null);

  const handleEyeClick = async (uid, index) => {
    try {
      const tasksResponse = await clientService.getClientTasks(uid);
      if (tasksResponse.success) {
        setTasksData((prevTasks) => [
          ...prevTasks,
          { index, tasks: tasksResponse.data.data.results },
        ]);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching client details:", error);
    } finally {
      setLoading(false);
      setLoadingIndex(null);
    }
  };

  const getTasksForRow = (index) => {
    const rowData = tasksData.find((data) => data.index === index);
    return rowData ? rowData.tasks : [];
  };

  // Remove 'created_at' and 'uid' from headers and always add 'action' column
  let tableHeaders = items?.[0]
    ? Object.keys(items[0]).filter(
        (key) => key !== "uid" && key !== "created_at"
      )
    : [];
  tableHeaders = [...tableHeaders, type === "client" ? "action" : ""];

  return (
    <div style={{ background: "#f2f6f9", padding: 14 }}>
      {/* For Mobile, Render Cards */}
      {isMobile ? (
        <div>
          {items?.map((item, index) => {
            const { uid, ...rest } = item;

            return (
              <div key={`${type}-${index}`}>
                <Card
                  style={{
                    marginBottom: 12,
                    background: "white",
                    borderRadius: "10px",
                    padding: "10px",
                    boxShadow:
                      "6px 6px 12px rgba(0, 0, 0, 0.1), -6px -6px 12px rgba(255, 255, 255, 0.7)",
                  }}
                  actions={[
                    type === "client" && (
                      <a
                        // target="_blank"
                        rel="noopener noreferrer"
                        href={`/client-orders/?username=${item.username}`}
                        style={{
                          fontWeight: 600,
                          color: "#2b63c6",
                          padding: 0,
                        }}
                        onClick={(e) => {
                          // Only open in new tab, not in current tab
                          e.stopPropagation();
                          // Let the browser handle opening the link in a new tab,
                          // but prevent React Router from hijacking the click in the current tab
                        }}>
                        View Orders
                      </a>
                    ),
                  ]}>
                  {Object.entries(rest).map(([key, value]) => (
                    <Descriptions
                      key={key}
                      bordered
                      style={{ marginBottom: "8px" }}>
                      <Descriptions.Item label={formatFieldName(key)}>
                        {key === "payment_links" ? (
                          <Popover
                            content={
                              <ul>
                                {Array.isArray(value) &&
                                  value.map((link, idx) => (
                                    <li key={idx}>
                                      <a
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        {link}
                                      </a>
                                    </li>
                                  ))}
                              </ul>
                            }
                            title="Payment Links">
                            <Button style={{ padding: 0 }} type="link">
                              View Links
                            </Button>
                          </Popover>
                        ) : key === "created_at" ? (
                          formatDate(value)
                        ) : key === "key" ? (
                          <Link
                            to={`/order-management/my-orders/${value}`}
                            style={{ textDecoration: "underline" }}>
                            {value}
                          </Link>
                        ) : key === "order_files" && Array.isArray(value) ? (
                          <Popover
                            content={
                              <ul style={{ paddingLeft: 16 }}>
                                {value.map((file, idx) => (
                                  <li key={idx}>
                                    <a
                                      href={file.file_url}
                                      target="_blank"
                                      rel="noopener noreferrer">
                                      {file.file_name || `File ${idx + 1}`}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            }
                            title="Attached Files">
                            <Button style={{ padding: 0 }} type="link">
                              View Files
                            </Button>
                          </Popover>
                        ) : key === "title" && typeof value === "string" ? (
                          (() => {
                            const words = value.split(" ");
                            if (words.length > 20 || value.length > 20) {
                              let truncated = value;
                              if (words.length > 20) {
                                truncated = words.slice(0, 20).join(" ");
                              }
                              if (truncated.length > 20) {
                                truncated = truncated.slice(0, 20);
                              }
                              return (
                                <Tooltip title={value}>{truncated} ...</Tooltip>
                              );
                            } else {
                              return value;
                            }
                          })()
                        ) : (
                          value
                        )}
                      </Descriptions.Item>
                    </Descriptions>
                  ))}
                </Card>
                {expandedRows[index] && (
                  <div
                    style={{
                      margin: "10px 0",
                      height: "100%",
                      padding: "10px",
                      background: "white",
                      borderRadius: "10px",
                      boxShadow:
                        "6px 6px 12px rgba(0, 0, 0, 0.1), -6px -6px 12px rgba(255, 255, 255, 0.7)",
                    }}>
                    {loadingIndex === index ? (
                      <div style={{ textAlign: "center" }}>
                        Loading Orders...
                      </div>
                    ) : (
                      <DynamicTable data={getTasksForRow(index)} />
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid #ddd",
                borderRadius: "10px",
                minWidth: 900,
              }}>
              {/* Table Header */}
              <thead>
                <tr
                  style={{
                    background: "#f1f3f5",
                    padding: "4px 8px",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    color: "#555",
                    marginBottom: 4,
                    textAlign: "left",
                  }}>
                  {tableHeaders.map((key) => (
                    <th
                      key={key}
                      style={{
                        padding: "8px",
                        textAlign: key === "action" ? "center" : "left",
                        background: key === "action" ? "#f1f3f5" : undefined,
                        zIndex: key === "action" ? 2 : undefined,
                      }}>
                      {key === "word"
                        ? "Word Count"
                        : key === "action"
                        ? "Action"
                        : formatFieldName(key)}
                    </th>
                  ))}
                </tr>
              </thead>

              {/* Table Body */}
              <tbody style={{ width: "100%", borderRadius: "10px" }}>
                {items?.map((item, index) => {
                  const { uid, ...rest } = item;

                  return (
                    <tr
                      key={`${type}-${index}`}
                      style={{
                        background: "white",
                        boxShadow:
                          "6px 6px 12px rgba(0, 0, 0, 0.1), -6px -6px 12px rgba(255, 255, 255, 0.7)",
                        padding: "15px 10px",
                        textAlign: "left",
                      }}>
                      {tableHeaders.map((key) => {
                        if (type === "client" && key === "action") {
                          return (
                            <td
                              key="action"
                              style={{
                                padding: "10px",
                                textAlign: "center",
                                borderRadius: "10px",
                                minWidth: 120,
                              }}>
                              <Button
                                type="link"
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  window.open(
                                    `/client-orders/?username=${item.username}`,
                                    "_blank"
                                  );
                                }}
                                style={{
                                  padding: 0,
                                  cursor: "pointer",
                                }}>
                                View Orders
                              </Button>
                            </td>
                          );
                        }
                        // All other columns
                        const value = rest[key];
                        let displayValue = value;
                        if (key === "title" && typeof value === "string") {
                          const words = value.split(" ");
                          if (words.length > 20 || value.length > 20) {
                            let truncated = value;
                            if (words.length > 20) {
                              truncated = words.slice(0, 20).join(" ");
                            }
                            if (truncated.length > 20) {
                              truncated = truncated.slice(0, 20);
                            }
                            displayValue = (
                              <Tooltip title={value}>{truncated} ...</Tooltip>
                            );
                          } else {
                            displayValue = value;
                          }
                        }

                        // Custom rendering for payment, amount_paid, and status columns
                        if (key === "payment") {
                          const payment = value;
                          if (!payment) return <td key={key}>N/A</td>;
                          const {
                            budget,
                            amount_paid,
                            currency,
                            payment_status,
                          } = payment;
                          const statusDotColor = {
                            Full: "green",
                            Partial: "yellow",
                            Unpaid: "red",
                          };
                          return (
                            <td key={key} style={{ minWidth: 180 }}>
                              <Space direction="vertical" size={0}>
                                <Typography.Text strong>
                                  {budget == null ||
                                  budget === "" ||
                                  currency == null ||
                                  currency === "" ||
                                  currency === "null"
                                    ? "N/A"
                                    : `${currency} ${budget}`}
                                </Typography.Text>
                                <Space>
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "8px",
                                      height: "8px",
                                      borderRadius: "50%",
                                      backgroundColor:
                                        statusDotColor[payment_status] ||
                                        "gray",
                                    }}></span>
                                  <Typography.Text
                                    type={
                                      payment_status === "Full"
                                        ? "success"
                                        : payment_status === "Partial"
                                        ? "warning"
                                        : "danger"
                                    }>
                                    {payment_status === "Full"
                                      ? "Paid"
                                      : payment_status === "Partial"
                                      ? "Partial"
                                      : "Unpaid"}
                                  </Typography.Text>
                                </Space>
                              </Space>
                            </td>
                          );
                        }
                        if (key === "amount_paid") {
                          const { amount_paid, currency } = rest?.payment || {};
                          return (
                            <td key={key} style={{ minWidth: 180 }}>
                              <Typography.Text>
                                {!currency ||
                                currency === "null" ||
                                currency === null ||
                                (!amount_paid && amount_paid !== 0)
                                  ? "N/A"
                                  : amount_paid === null ||
                                    amount_paid === undefined
                                  ? "N/A"
                                  : !currency
                                  ? "N/A"
                                  : `${currency} ${amount_paid}`}
                              </Typography.Text>
                            </td>
                          );
                        }
                        if (key === "status") {
                          const statusColors = {
                            Unassigned: "#F0F0F0",
                            "Assigned to manager": "#C0C0C0",
                            "In Progress": "#D0E4F2",
                            "Quality Check": "#A9C3E0",
                            Completed: "#C8E6C8",
                            Delivered: "#8FCF8F",
                            Rejected: "#E8A0A0",
                            Cancelled: "#A0A0A0",
                            "Cancelled by User": "#A0A0A0",
                            Failed: "#D09090",
                            Feedback: "#C2A892",
                          };
                          return (
                            <td key={key}>
                              <Tag
                                style={{ color: "black", fontWeight: 500 }}
                                color={statusColors[value] || "default"}>
                                {value}
                              </Tag>
                            </td>
                          );
                        }
                        return (
                          <td
                            key={key}
                            style={{
                              padding: "10px",
                              textAlign: "left",
                              borderRadius: "10px",
                              minWidth: key === "name" ? 180 : undefined,
                            }}>
                            <Tooltip
                              key={key}
                              title={
                                key === "ownership" || key === "visibility"
                                  ? value
                                  : null
                              }
                              placement="topLeft">
                              <div
                                style={{
                                  margin: 0,
                                  padding: 0,
                                  wordBreak: "break-word",
                                }}>
                                {key === "name" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}>
                                    <span>{value}</span>
                                    {item.created_at && (
                                      <span
                                        style={{
                                          fontSize: 12,
                                          color: "#888",
                                          marginTop: 2,
                                        }}>
                                        {formatDate(item.created_at)}
                                      </span>
                                    )}
                                  </div>
                                ) : key === "title" &&
                                  typeof value === "string" ? (
                                  displayValue
                                ) : key === "ownership" ||
                                  key === "visibility" ? (
                                  Array.isArray(value) && value.length > 2 ? (
                                    <Popover
                                      content={
                                        <ul>
                                          {value.slice(2).map((name, idx) => (
                                            <li key={idx}>{name}</li>
                                          ))}
                                        </ul>
                                      }
                                      title="Visibility">
                                      <div>
                                        {value.slice(0, 2).map((name, idx) => (
                                          <Avatar
                                            key={idx}
                                            style={{
                                              backgroundColor: "#87d068",
                                              verticalAlign: "middle",
                                              marginRight: 5,
                                            }}
                                            size="small">
                                            {name
                                              .split(" ")
                                              .map((n) => n[0].toUpperCase())
                                              .slice(0, 2)
                                              .join("")}
                                          </Avatar>
                                        ))}
                                        {value.length > 2 && (
                                          <span> +{value.length - 2}</span>
                                        )}
                                      </div>
                                    </Popover>
                                  ) : (
                                    <div>
                                      {Array.isArray(value) ? (
                                        value.map((name, idx) => (
                                          <Avatar
                                            key={idx}
                                            style={{
                                              backgroundColor: "#87d068",
                                              verticalAlign: "middle",
                                              marginRight: 5,
                                            }}
                                            size="small">
                                            {name
                                              .split(" ")
                                              .map((n) => n[0].toUpperCase())
                                              .slice(0, 2)
                                              .join("")}
                                          </Avatar>
                                        ))
                                      ) : (
                                        <Avatar
                                          style={{
                                            backgroundColor: "#87d068",
                                            verticalAlign: "middle",
                                          }}
                                          size="small">
                                          {value
                                            .split(" ")
                                            .map((n) => n[0].toUpperCase())
                                            .slice(0, 2)
                                            .join("")}
                                        </Avatar>
                                      )}
                                    </div>
                                  )
                                ) : key === "created_at" ? null : key ===
                                  "word" ? (
                                  <Tag color="orange">{value}</Tag>
                                ) : key === "key" ? (
                                  <a
                                    href={`/order-management/my-orders/${value}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: "underline" }}>
                                    {value}
                                  </a>
                                ) : key === "email" ? (
                                  <Popover content={value} title="Email">
                                    <Button style={{ padding: 0 }} type="link">
                                      View Email
                                    </Button>
                                  </Popover>
                                ) : key === "website" ? (
                                  <Tag color="green">{value}</Tag>
                                ) : key === "payment_links" &&
                                  Array.isArray(value) ? (
                                  <Popover
                                    content={
                                      <ul>
                                        {value.map((link, idx) => (
                                          <li key={idx}>
                                            <a
                                              href={link}
                                              target="_blank"
                                              rel="noopener noreferrer">
                                              {link}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    }
                                    title="Payment Links">
                                    <Button type="link">View Links</Button>
                                  </Popover>
                                ) : key === "order_files" &&
                                  Array.isArray(value) ? (
                                  <Popover
                                    content={
                                      <ul style={{ paddingLeft: 16 }}>
                                        {value.map((file, idx) => (
                                          <li key={idx}>
                                            <a
                                              href={file.file_url}
                                              target="_blank"
                                              rel="noopener noreferrer">
                                              {file.file_name ||
                                                `File ${idx + 1}`}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    }
                                    title="Attached Files">
                                    <Button type="link" style={{ padding: 0 }}>
                                      View Files
                                    </Button>
                                  </Popover>
                                ) : (
                                  displayValue
                                )}
                              </div>
                            </Tooltip>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {items?.map((item, index) => {
            const { uid } = item;

            return (
              expandedRows[index] && (
                <div
                  key={`${type}-${index}-expanded`}
                  style={{
                    margin: "10px 0",
                    padding: "10px",
                    background: "white",
                    borderRadius: "10px",
                    boxShadow:
                      "6px 6px 12px rgba(0, 0, 0, 0.1), -6px -6px 12px rgba(255, 255, 255, 0.7)",
                  }}>
                  {loading ? (
                    <Flex
                      justify="center"
                      align="center"
                      style={{ width: "100%" }}>
                      <Spin size="large"></Spin>
                    </Flex>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <DynamicTable data={getTasksForRow(index)} />
                    </div>
                  )}
                </div>
              )
            );
          })}
        </>
      )}
    </div>
  );
};

export default SearchDescriptionsList;
